export const codeErrorResponse = (codeErr, section) => {

    let codeE = String(codeErr)

    let catalogo = {
        "ERR000" : "Error no especificado contactar sistemas",
        "ERR001" : "Número de tarjeta inválida, verifique…",
        "ERR002" : "Nombre inválido, verifique…",
        "ERR003" : "Tarjeta con código de rechazo",
        "ERR004" : "Cuenta con atraso",
        "ERR005" : "Tarjeta con límite de crédito en cero",
        "ERR006" : "Error técnico",
        "ERR007" : "¡Lo sentimos!, no puedes registrar esta tarjeta ya se encuentra asociada a otra cuenta CLAROSHOP.",
        "ERR008" : "no se tiene el error registrado en los datos de claroshop",
        "ERR009" : "no se tiene el error registrado en los datos de claroshop",
        "ERR010" : "Número de tarjeta o usuario incorrecto",
        "ERR011" : "Error no especificado contactar sistemas",
        "ERR029" : "no se tiene el error registrado en los datos de claroshop",
        "ER00000000" : "Error no especificado contactar sistemas",
        "ER00000001" : "Falta nombre",
        "ER00000002" : "Nombre con caracteres inválidos",
        "ER00000003" : "Falta apellido paterno",
        "ER00000004" : "Apellido Paterno con caracteres inválidos",
        "ER00000005" : "Apellido materno con caracteres inválidos",
        "ER00000006" : "fecha nacimiento mayor a 8 caracteres",
        "ER00000007" : "Edad tiene más de dos caracteres",
        "ER00000008" : "Edad no numérico",
        "ER00000009" : "falta dirección",
        "ER00000010" : "falta colonia",
        "ER00000011" : "falta ciudad",
        "ER00000012" : "falta estado",
        "ER00000013" : "estado mayor a dos caracteres",
        "ER00000014" : "falta cp",
        "ER00000015" : "cp mayor a cinco caracteres",
        "ER00000016" : "cp no es numérico",
        "ER00000017" : "falta teléfono",
        "ER00000018" : "teléfono mayor a 10 caracteres",
        "ER00000019" : "teléfono no es numérico",
        "ER00000020" : "Falta TiempoResAnio",
        "ER00000021" : "Tiempo residencia año mayor a 2 caracteres",
        "ER00000022" : "Tiempo residencia año no es numérico",
        "ER00000023" : "Falta TiempoResMes",
        "ER00000024" : "Tiempo residencia meses nacimiento mayor a 2 caracteres",
        "ER00000025" : "Tiempo residencia meses no es numérico",
        "ER00000026" : "Tiempo residencia meses mayor a 11",
        "ER00000027" : "Monto renta requerido cuando el tipo de vivienda es R",
        "ER00000028" : "Monto renta mayor 10 caracters",
        "ER00000029" : "Monto renta caracteres inválidos",
        "ER00000030" : "TipoVivienda requerido",
        "ER00000031" : "TipoVivienda mayor a dos caracteres",
        "ER00000032" : "Tiempo vivienda caracteres inválidos",
        "ER00000033" : "No. dependientes mayor a dos caracteres",
        "ER00000034" : "No. dependientes caracteres inválidos",
        "ER00000035" : "TipoEmpresa mayor a dos caracteres",
        "ER00000036" : "TipoEmpresa caracteres inválidos",
        "ER00000037" : "Falta Tiempo en empresa en años",
        "ER00000038" : "Tiempo en empresa año mayor a 2 caracteres",
        "ER00000039" : "Tiempo en empresa año caracteres inválidos",
        "ER00000040" : "Falta Tiempo en empresa meses",
        "ER00000041" : "Tiempo en empesa en meses mayor a 2 caracteres",
        "ER00000042" : "Tiempo en empresa meses no es numérico",
        "ER00000043" : "Tiempo en empresa meses mayor a 11",
        "ER00000044" : "Falta ocupación",
        "ER00000045" : "Ocupación mayor a 2 caracteres",
        "ER00000046" : "Ocupación caracteres inválidos",
        "ER00000047" : "Falta Ingreso mensual",
        "ER00000048" : "Ingreso mensual mayor a 2 caracteres",
        "ER00000049" : "Ingreso mensual caracteres inválidos",
        "ER00000050" : "Falta Dirección Empleo",
        "ER00000051" : "Falta Ciudad empleo",
        "ER00000052" : "Falta Estado Empleo",
        "ER00000053" : "Estado Empleo mayor a 2 caracteres",
        "ER00000054" : "Falta CP Empleo",
        "ER00000055" : "CP Empleo mayor a 5 caracteres",
        "ER00000056" : "CP Empleo debe ser numérico",
        "ER00000057" : "Falta Teléfono Empleo",
        "ER00000058" : "teléfono empleo debe ser 10 caracteres",
        "ER00000059" : "telefono empleo es numérico",
        "ER00000060" : "extensión diferente de 4 dígitos",
        "ER00000061" : "OtroIngresos mayor a 10 posiciones",
        "ER00000062" : "OtroIngresos es numérico",
        "ER00000063" : "Falta RFC",
        "ER00000064" : "RFC mal escrito",
        "ER00000065" : "Tarjeta Credito es mayor 20 caracteres",
        "ER00000066" : "Tarjeta Credito es numérico",
        "ER00000067" : "Email sin estructura",
        "ER00000068" : "No hay colonia de la referencia 1",
        "ER00000069" : "No hay Teléfono 1",
        "ER00000070" : "Teléfono 1 tiene que ser 10 posiciones",
        "ER00000071" : "Teléfono Referencia1 no es numérico",
        "ER00000072" : "No hay parentesco 1",
        "ER00000073" : "Parentesco 1 tiene que ser 1 posición",
        "ER00000074" : "Parentesco 1 caracteres inválidos",
        "ER00000075" : "No hay colonia de la referencia 2",
        "ER00000076" : "No hay Teléfono 2",
        "ER00000077" : "Teléfono 2 tiene que ser 10 posiciones",
        "ER00000078" : "Teléfono Referencia2 no es numérico",
        "ER00000079" : "No hay parentesco 2",
        "ER00000080" : "Parentesco 2 tiene que ser 1 posición",
        "ER00000081" : "Parentesco 2 caracteres inválidos",
        "ER00000082" : "Teléfono 3 tiene que ser 10 posiciones",
        "ER00000083" : "Teléfono Referencia3 no es numérico",
        "ER00000084" : "Parentesco 3 tiene que ser 1 posición",
        "ER00000085" : "Parentesco 3 caracteres inválidos",
        "ER00000086" : "Falta Género",
        "ER00000087" : "Género mayor a 1 carácter",
        "ER00000088" : "Género caracteres inválidos",
        "ER00000089" : "Falta Starjeta",
        "ER00000090" : "STarjeta mayor a 2 caracteres",
        "ER00000091" : "STarjeta caracteres inválidos",
        "ER00000092" : "Dígitos tienen que ser 4",
        "ER00000093" : "Dígitos tienen que ser numérico",
        "ER00000094" : "Falta Shipotecario",
        "ER00000095" : "SHipotecario mayor a 2 caracteres",
        "ER00000096" : "SHipotecario caracteres inválidos",
        "ER00000097" : "Falta Sautomotriz",
        "ER00000098" : "SAutomotriz mayor a 2 caracteres",
        "ER00000099" : "SAutomotriz caracteres inválidos",
        "ER00000100" : "Falta Autorización",
        "ER00000101" : "Autorización mayor a 2 caracteres",
        "ER00000102" : "Autorización caracteres inválidos",
        "ER00000103" : "Celular debe ser obligatorio",
        "ER00000104" : "Celular debe ser 10 posiciones",
        "ER00000105" : "Celular debe ser numérico",
        "FL00000000" : "Fuera de línea",
        "UnsupportedApiVersion" : "The HTTP resource that matches the request URI 'http://10.128.14.47:6062/credito-sears/v1/cards/movements' does not support HTTP method 'GET'.",
        "ER0PAY0" : "¡Lo sentimos! No podemos continuar, la cantidad mínima para realizar un pago es de $1.00",
    }

    if(section === "formShort"){
        catalogo = {
            "ERR001": "Falta nombre",
            "ERR002": "Nombre con caracteres inválidos",
            "ERR003": "Falta apellido paterno",
            "ERR004": "Apellido Paterno con caracteres inválidos",
            "ERR005": "Apellido materno con caracteres inválidos",
            "ERR006": "fecha nacimiento mayor a 8 caracteres",
            "ERR009": "falta dirección",
            "ERR010": "falta colonia",
            "ERR011": "falta ciudad",
            "ERR012": "falta estado",
            "ERR013": "estado mayor a dos caracteres",
            "ERR014": "falta cp",
            "ERR015": "cp mayor a cinco caracteres",
            "ERR016": "cp no es numérico",
            "ERR017": "falta teléfono",
            "ERR018": "teléfono mayor a 10 caracteres",
            "ERR019": "teléfono no es numérico",
            "ERR020": "Falta TiempoResAnio",
            "ERR021": "Tiempo residencia año mayor a 2 caracteres",
            "ERR022": "Tiempo residencia año no es numérico",
            "ERR023": "Falta TiempoResMes",
            "ERR024": "Tiempo residencia meses nacimiento mayor a 2 caracteres",
            "ERR025": "Tiempo residencia meses no es númerico",
            "ERR026": "Tiempo residencia meses mayor a 11",
            "ERR027": "Monto renta requerido cuando el tipo de vivienda es R",
            "ERR028": "Monto renta mayor 10 caracteres",
            "ERR029": "Monto renta caracteres inválidos",
            "ERR030": "TipoVivienda requerido",
            "ERR031": "TipoVivienda mayor a dos caracteres",
            "ERR032": "Tiempo vivienda caracteres inválidos",
            "ERR033": "No. dependientes mayor a dos caracteres",
            "ERR034": "No. dependientes caracteres inválidos",
            "ERR035": "TipoEmpresa mayor a dos caracteres",
            "ERR036": "TipoEmpresa caracteres inválidos",
            "ERR037": "Falta Tiempo en empresa en años",
            "ERR038": "Tiempo en empresa año mayor a 2 caracteres",
            "ERR039": "Tiempo en empresa año caracteres inválidos",
            "ERR040": "Falta Tiempo en empresa meses",
            "ERR041": "Tiempo en empesa en meses mayor a 2 caracteres",
            "ERR042": "Tiempo en empresa meses no es numérico",
            "ERR043": "Tiempo en empresa meses mayor a 11",
            "ERR044": "Falta ocupación",
            "ERR045": "Ocupación mayor a 2 caracteres",
            "ERR046": "Ocupación caracteres inválidos",
            "ERR047": "Falta Ingreso mensual",
            "ERR048": "Ingreso mensual mayor a 2 caracteres",
            "ERR049": "Ingreso mensual caracteres inválidos",
            "ERR050": "Falta Dirección Empleo",
            "ERR054": "Falta CP Empleo",
            "ERR055": "CP Empleo mayor a 5 caracteres",
            "ERR056": "CP Empleo debe ser numérico",
            "ERR057": "Falta Teléfono Empleo",
            "ERR058": "teléfono empleo debe ser 10 caracteres",
            "ERR059": "teléfono empleo es numérico",
            "ERR060": "extensión diferente de 4 digitos",
            "ERR061": "Otro Ingresos mayor a 10 posiciones",
            "ERR062": "Otro Ingresos es númerico",
            "ERR063": "Falta RFC",
            "ERR064": "RFC mal escrito",
            "ERR067": "Email sin estructura",
            "ERR086": "Falta Género",
            "ERR087": "Género mayor a 1 carácter",
            "ERR088": "Género caracteres inválidos",
            "ERR089": "Falta Starjeta",
            "ERR090": "STarjeta mayor a 2 caracteres",
            "ERR091": "STarjeta caracteres inválidos",
            "ERR092": "Digitos tienen que ser 4",
            "ERR093": "Digitos tienen que ser numérico",
            "ERR094": "Falta Shipotecario",
            "ERR095": "SHipotecario mayor a 2 caracteres",
            "ERR096": "SHipotecario caracteres inválidos",
            "ERR097": "Falta Sautomotriz",
            "ERR098": "SAutomotriz mayor a 2 caracteres",
            "ERR099": "SAutomotriz caracteres inválidos",
            "ERR100": "Falta Autorización",
            "ERR101": "Autorización mayor a 2 caracteres",
            "ERR102": "Autorización caracteres inválidos",
            "ERR103": "Celular debe ser obligatorio",
            "ERR104": "Celular debe ser 10 posiciones",
            "ERR105": "Celular debe ser numérico",
            "ERR107": "Información incompleta",
            "FL000": "Fuera de línea",
            "ERR000": "Error no especificado contactar sistemas"
        }
    }

    if(section === "addCardSears"){
        catalogo = {
            "ERR000" : "Error no especificado contactar sistemas",
            "ERR001" : "Número de tarjeta inválida, verifique…",
            "ERR002" : "Nombre inválido, verifique…",
            "ERR003" : "Tarjeta con código de rechazo",
            "ERR004" : "Cuenta con atraso",
            "ERR005" : "Tarjeta con límite de crédito en cero",
            "ERR006" : "Error técnico",
            "ERR007" : "¡Lo sentimos!, no puedes registrar esta tarjeta ya se encuentra asociada a otra cuenta claroshop.",
            "ERR008" : "no se tiene el error registrado en los datos de claroshop",
            "ERR009" : "no se tiene el error registrado en los datos de claroshop",
            "ERR010" : "Número de tarjeta o usuario incorrecto",
            "ERR011" : "Error no especificado contactar sistemas",
            "ERR011" : "Por favor, valida que los datos que ingresaste sean correctos."
        }
    }

    if(section === "choiseCards" || section === "addCard"){
        catalogo = {
            "30" : "Por favor valida que los datos sean correctos o elige otra forma de pago.",
            "31" : "Tu banco rechazo la compra, favor de comunicarte con ellos o elige otra forma de pago.",
            "32" : "Tu banco rechazo la compra, favor de comunicarte con ellos o elige otra forma de pago.",
            "33" : "Hemos cerrado tu sesión por motivos de seguridad.",
            "34" : "Tu tarjeta no esta habilitada para compras por Internet, por favor, comunicate con tu banco o elige otra forma de pago.",
            "35" : "Tu compra no fue autorizada, por favor elige otra forma de pago"
        }
    }

    if(section === "paperLess"){
        catalogo = {
            "01": "Cuenta no existe",
            "02": "Error de formato",
            "03": "Error de base de datos",
            "04": "Error Genérico",
            "05": "Tipo de cuenta inválida",
            "06": "Correo electrónico inválido",
            "07": "Opción marcada inválida",
            "08": "Autorización no seleccionada",
            "09": "ID Aplicativo no existe"
        }
    }
    
    let messageError = catalogo[codeE]

    return messageError
}